export default function formatTwoDigits(number) {
    return ('0' + number).slice(-2)
}
